import {Provider} from '@angular/core';
import {
  DefaultFallbackStrategy,
  DefaultInterceptor,
  DefaultMissingHandler,
  DefaultTranspiler,
  TRANSLOCO_CONFIG,
  TRANSLOCO_FALLBACK_STRATEGY,
  TRANSLOCO_INTERCEPTOR,
  TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER,
  TRANSLOCO_TRANSPILER,
} from '@jsverse/transloco';
import {APP_PROD_MODE} from '../app-prod-mode.token';
import {translocoConfigFactory} from './transloco.config';
import {DirectusTranslocoLoader} from '../directus';

export function provideTranslocoConfig(): Provider[] {
  return [
    {
      provide: TRANSLOCO_CONFIG,
      useFactory: translocoConfigFactory,
      deps: [APP_PROD_MODE],
    },
    {provide: TRANSLOCO_LOADER, useClass: DirectusTranslocoLoader},
    {provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler},
    {provide: TRANSLOCO_MISSING_HANDLER, useClass: DefaultMissingHandler},
    {provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor},
    {provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy},
  ];
}
